module.exports = __webpack_public_path__ + "img/api-paywall-background.ef0eddb9.jpg";